module.exports = __webpack_public_path__ + "static/media/cat3.e0735ee7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat3.jpeg
// module id = 35
// module chunks = 0